export default __webpack_public_path__ + "static/media/icone-lixeira-cinza.5b889c89.svg";